export default __webpack_public_path__ + "static/media/play_new_1.89e04c85.svg";